import { ReactElement, ReactNode } from 'react';
import { TextField } from '@mui/material';

import { PaloFormikField } from './palo-formik-field';

export interface PaloTextControlProps {
    name: string;
    label: ReactNode;
    required?: boolean;
    multiline?: boolean;
    /** Rows a multiline field starts with (default 4). */
    minRows?: number;
    /** Rows a multiline field grows to before it scrolls; unset, it keeps growing. */
    maxRows?: number;
    span?: number;
    area?: string;
    autoFocus?: boolean;
    disabled?: boolean;
}

/** Formik-bound dense text field wrapped in a PALO labelled field. */
export const PaloTextControl = ({
    name,
    label,
    required,
    multiline,
    minRows = 4,
    maxRows,
    span,
    area,
    autoFocus,
    disabled,
}: PaloTextControlProps): ReactElement => (
    <PaloFormikField<string> name={name} label={label} required={required} span={span} area={area}>
        {({ field, hasError }) => (
            <TextField
                {...field}
                value={field.value ?? ''}
                size="small"
                fullWidth
                multiline={multiline}
                minRows={multiline ? minRows : undefined}
                maxRows={multiline ? maxRows : undefined}
                autoFocus={autoFocus}
                disabled={disabled}
                error={hasError}
            />
        )}
    </PaloFormikField>
);
